export default {
  state: {
    previousRouterName: null,
  },

  mutations: {
    SET_PREVIOUS_ROUTER(state, routerName) {
      state.previousRouterName = routerName
    },
  },

  actions: {
    setPreviousRouter({ commit }, routerName) {
      commit('SET_PREVIOUS_ROUTER', routerName)
    },
  },

  getters: {
    previousRouterName: (state) => state.previousRouterName,
  },
}
